import * as React from 'react';
import {Button, Dialog, DialogActions, DialogContent} from '@material-ui/core';
import {compose, Dispatch} from 'redux';
import {withTranslation} from 'react-i18next';
import {TFunction} from 'i18next';
import Cookies from 'js-cookie';
import {cookieNameDefaultTemplateDialogWasShown, mailtoSupport} from '../../constants';
import {connect} from 'react-redux';
import {toggleDefaultTemplateDialogOpen} from '../../actions';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {

}

interface InnerProps extends Props {
    t: TFunction;
    dispatch: Dispatch;
    needToShowDialog: boolean;
}

interface State {
    isOpen: boolean;
}

class DialogView extends React.Component<InnerProps, State> {
    constructor(props: InnerProps) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    componentDidUpdate(prevProps: Readonly<InnerProps>): void {
        const {needToShowDialog: prevNeedToShowDialog} = prevProps;
        const {needToShowDialog} = this.props;

        if (!prevNeedToShowDialog && needToShowDialog) {
            this.setState({isOpen: true});
        }
    }

    onButtonClick = (): void => {
        const {dispatch} = this.props;
        this.setState({isOpen: false});
        Cookies.set(cookieNameDefaultTemplateDialogWasShown, 'true');
        dispatch(toggleDefaultTemplateDialogOpen(false));
    };

    render(): React.ReactElement {
        const {t: translate} = this.props;
        const {isOpen} = this.state;

        return (
            <Dialog
                open={isOpen}
                disableEscapeKeyDown
                disableBackdropClick
            >
                <DialogContent>
                    <p>Hi,</p>
                    <p>It seems ScanDocFlow does not have necessary rules to extract key data from your document/layout/supplier yet.</p>
                    <p>We create those rules to extract as many information from your document as you may need and we will send you a notification
                        once rules are created.</p>
                    <p>Please feel free to check our app after you receive notification and please feel free to reach us out
                        at <a href={mailtoSupport}>support@scandocflow.com</a> if you have any questions.</p>
                </DialogContent>
                <DialogActions>
                    <Button
                        color='primary'
                        onClick={this.onButtonClick}
                    >
                        {translate('common.actions.ok')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

// @ts-ignore
const DefaultTemplateRecognitionDialog: React.FunctionComponent<Props> = compose(
    withTranslation(),
    connect((state: any) => ({
            needToShowDialog: state.settings.needToShowDefaultTemplateDialog,
        }),
        null,
    ),
)(DialogView);

export default DefaultTemplateRecognitionDialog;